<div class="box-header">
  <ng-content select="[slot=header]"></ng-content>
</div>
<div class="box-content">
  <ng-content></ng-content>
</div>
